<template>
  <RxkDrawer
    v-model="visible"
    :size="1600"
    :isLoading="true"
    :showCancelBtn="false"
    :footer="false"
    :append-to-body="true"
    custom-class="contract-details-drawer"
    @close="close"
  >
    <template #header>
      <span></span>
    </template>
    <template #content>
      <ContractDetails
        style="height: 100%; overflow: auto"
        :modelValue="show"
        :isDialog="true"
        :contractId="contractId"
        :contractType="type"
        @update:modelValue="hanldeClose"
      ></ContractDetails>
    </template>
  </RxkDrawer>
</template>
<script lang="ts" setup>
import { RxkDrawer } from '@/components/common/RxkDrawer'
import { computed } from 'vue'
import ContractDetails from './ContractDetails.vue'

const props = defineProps({
  modelValue: Boolean,
  contractId: String,
  type: String as PropType<'sign' | 'remove'>
})

const emits = defineEmits(['update:modelValue', 'selected'])

const visible = computed({
  get: () => props.modelValue,
  set: val => {
    emits('update:modelValue', val)
  }
})

watch(visible, val => {
  if (val) {
    setTimeout(() => {
      show.value = true
    })
  } else {
    show.value = false
  }
})
const show = ref(false)
function close() {
  emits('update:modelValue', false)
}

function hanldeClose() {
  close()
}
</script>
<style lang="scss">
.contract-details-drawer {
  .el-drawer__header {
    display: none;
  }
  .el-drawer__content {
    position: relative;
  }
}
</style>
